"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _constants = _interopRequireDefault(require("@ahmdigital/constants"));
var _isValidScale = _interopRequireDefault(require("../is-valid-scale"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SINGLE_SCALES = [_constants["default"].SCALE.SINGLE];
var _default = exports["default"] = (0, _fp.memoize)(function (scale) {
  if (!(0, _isValidScale["default"])(scale)) {
    return _constants["default"].INCOME_TYPE.SINGLE;
  }
  return (0, _fp.includes)(scale, SINGLE_SCALES) ? _constants["default"].INCOME_TYPE.SINGLE : _constants["default"].INCOME_TYPE.COUPLE;
});
module.exports = exports.default;